import moment from '~/_moment';
import { REQUEST } from '~/middleware/ndsRequest';

const requestData = (options) => ({
  [REQUEST]: options,
});

export const PressureActionTypes = {
  SET_DATE: 'setFilterDate',
  SET_START_TIME: 'setStartTime',
  SET_END_TIME: 'setEndTime',
  SET_FILTER_DATE_TIME: 'setFilterDateTime',
  LOAD_PRESSURE: 'loadPressureSimulate',
  RESET_PRESSURE: 'resetPressureSimulate',
  RESET_IS_LOADING: 'resetIsLoading',
};

export default {
  changeDate: (dateFormated) => (dispatch) =>
    dispatch({
      type: PressureActionTypes.SET_DATE,
      dateFormated,
    }),
  changeStartTime: (timeFormated) => (dispatch) =>
    dispatch({
      type: PressureActionTypes.SET_START_TIME,
      timeFormated,
    }),
  changeEndTime: (timeFormated) => (dispatch) =>
    dispatch({
      type: PressureActionTypes.SET_END_TIME,
      timeFormated,
    }),
  setFilterDateTime: (filters) => (dispatch) =>
    dispatch({
      type: PressureActionTypes.SET_FILTER_DATE_TIME,
      date: filters.date,
      startTime: filters.startTime,
      endTime: filters.endTime,
    }),
  loadPressureData: (getDate = false) => (dispatch, getState) => {
    const {
      Pressure: { date, startTime, endTime },
    } = getState();
    // reset isLoading flag
    dispatch({ type: PressureActionTypes.RESET_IS_LOADING });

    const start = getDate
      ? `${getDate} 00:00:00`
      : moment(date, 'YYYY-MM-DD').format(`YYYY-MM-DD ${startTime}:00`);
    const end = getDate
      ? `${getDate} 23:59:59`
      : moment(date, 'YYYY-MM-DD').format(`YYYY-MM-DD ${endTime}:00`);

    return dispatch(
      requestData({
        type: PressureActionTypes.LOAD_PRESSURE,
        endpoint: `/rest/pressure?start=${start}&end=${end}`,
        method: 'GET',
      }),
    );
  },
  resetPressureData: () => (dispatch) => dispatch({ type: PressureActionTypes.RESET_PRESSURE }),
};



// WEBPACK FOOTER //
// ./resources/assets/js/actions/pressure.js